<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/aboutUs/03/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="l-x-w-m page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="l-x-w-m-content">
                            <div class="title">
                                <span>联系</span>
                                <span>我们</span>
                            </div>
                            <div ref="map" class="map max-size"/>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="page-content-child"-->
<!--                v-for="(src,i) of imgArr"-->
<!--                :key="i"-->
<!--            >-->
<!--                <div class="content-w">-->
<!--                    <img :src="src" width="100%" alt="" />-->
<!--                </div>-->
<!--            </div>            -->
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    require('@/assets/image/aboutUs/03/pic-1.png'),
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            },
            async initMap(map, mapMarker) {
                const AMap = await this.$GetAMap
                const addMarker = (item, i) => {
                    let marker = null
                    var icon = new AMap.Icon({
                        image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png',
                        imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
                    })
                    marker = new AMap.Marker({
                        map: map,
                        position: [item.lng, item.lat],
                        icon
                    })
                    var e_content = document.createElement('div')
                    e_content.classList.add('mapLabel')
                    e_content.innerHTML =
                        `<div class="map-info">
                            <div class="map-info-text">商务：${item.swPhone} </div>
                            <div class="map-info-text">技术：${item.jsPhone} </div>
                            <div class="map-info-text">邮箱：${item.email} </div>
                            <div class="map-info-text">地址：${item.address} </div>
                        </div>`
                    // 实例化信息窗体
                    var infoWindow = new AMap.InfoWindow({
                        isCustom: true, // 使用自定义窗体
                        closeWhenClickMap: true,
                        autoMove: true,
                        anchor: 'middle-left',
                        content: e_content,
                        offset: new AMap.Pixel(40, 10)
                    })
                    marker.on('mouseout', () => {
                        marker.setIcon(new AMap.Icon({
                            image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png', //
                            imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
                        }))
                        infoWindow.close()
                    })
                    // 鼠标点击marker弹出自定义的信息窗体
                    marker.on('mousemove', () => {
                        marker.setIcon(new AMap.Icon({
                            size: new AMap.Size(24, 36), // 图标尺寸
                            image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png', //
                            imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
                            imageSize: new AMap.Size(24, 36) // 根据所设置的大小拉伸或压缩图片
                        }))
                        infoWindow.open(map, marker.getPosition())
                    })
                    infoWindow.open(map, marker.getPosition())
                    return marker
                }
                const markers = []
                mapMarker.forEach((item, i) => {
                    if (item.lng && item.lat) {
                        const marker = addMarker(item, i)
                        map.add(marker)
                        markers.push(marker)
                    }
                })
                console.log(markers,'markers')
                return markers
            },
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
       async mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);

            const AMap = await this.$GetAMap
            const map = new AMap.Map(this.$refs.map, { // 地图
                resizeEnable: false,
                zoom: 18,
                center: [114.422800 , 30.485299]
            })

           let mapMarker = [
               {
                   lng:120.774365,
                   lat:30.733265,
                   swPhone:'18086485172',
                   jsPhone:'18086462921',
                   email:'zjh@launchso.com',
                   address:'浙江省嘉兴市南湖区东栅街道富润路257号2幢202室'
               }
           ]
           this.initMap(map,mapMarker)
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        /*background-color:#f0f2f5;*/
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }

    .page-content{
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(n){
        background-color:#ffffff;
    }

    .page-content-child .title span:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }
    .page-content-child .title span:nth-child(2){
        color:#2FA8D0;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
        min-height:500px;
    }

    .l-x-w-m .l-x-w-m-content{
        text-align: center;
        padding:102px 0 187px 0;
    }

    .l-x-w-m .map{
        width:100%;
        height: 820px;
        margin-top:212px;
    }

    .map /deep/ .mapLabel{
        background: #ffffff;
        opacity: 0.9;
        border: 1px solid #D0D0D0;
    }

    .map /deep/ .map-info{
        display: flex;
        flex-flow: column wrap;
        padding: 30px 30px;
        width: 350px;
        /*max-width: 350px;*/
        position: relative;
    }

    .map /deep/ .map-info-text{
        text-align: left;
        font-size: 16px;
        font-weight: 400;
        color: #555555;
        line-height: 40px;
    }

    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){

    }

    @media screen and (max-width: 1200px){
        .l-x-w-m .l-x-w-m-content{
            padding:80px 0 160px 0;
        }

        .l-x-w-m .map{
            margin-top:180px;
        }
    }

    @media screen and (max-width: 960px){
        .l-x-w-m .l-x-w-m-content{
            padding:60px 0 140px 0;
        }

        .l-x-w-m .map{
            margin-top:100px;
        }
    }

    @media screen and (max-width: 760px){
        .l-x-w-m .l-x-w-m-content{
            padding:60px 0 60px 0;
        }

        .l-x-w-m .map{
            margin-top:50px;
        }
    }
</style>
